import { useState, useRef } from "react";
import { Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import Loader from "../../../components/loader";
import UiButton from "../../../components/button";
import TextInput from "../../../components/textinput/TextInput";
import {
  useSupportedTokens,
  useSecurityTokenDetails,
  useNetworkOptions,
} from "../../../context/contractDataLoaderService";
import Web3 from "web3";
import ERC20ABI from "../../../utils/abi/ERC20.json";
import {
  SecondaryIssueManager,
  SecuritiesFactory,
  contractAddress,
  Security,
  ERC20,
} from "@verified-network/verified-sdk";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { ethers, providers } from "ethers";
import { useGlobal } from "../../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../../utils/helpers";

function NewOffer(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [securityAmount, setSecurityAmount] = useState("");
  const [enteredSecurity, setEnteredSecurity] = useState("");
  const [currencyName, setCurrencyName] = useState("Select Currency");
  const [minOrderSize, setMinOrderSize] = useState("");
  const [currencyAmount, setCurrencyAmount] = useState("");
  const [issuingFee, setIssuingFee] = useState("");
  const [securityOutstanding, setSecurityOutstanding] = useState();
  const [changeContent, setChangeContent] = useState(false);
  const { data: networkOptions } = useNetworkOptions("issue");
  const modalContent = useRef(null);
  const [id, setId] = useState("");

  let secondaryIssueContract, factoryContract, securityContract;
  let { data } = useSupportedTokens();
  if (provider && provider.getSigner && chainId && address) {
    if (contractAddress[chainId].BalancerSecondaryIssueManager) {
      secondaryIssueContract = new SecondaryIssueManager(
        signer,
        contractAddress[chainId].BalancerSecondaryIssueManager,
      );
    }
    if (contractAddress[chainId].SecuritiesFactory) {
      factoryContract = new SecuritiesFactory(
        signer,
        contractAddress[chainId].SecuritiesFactory,
      );
    }
  }

  const addIssue = async () => {
    if (minOrderSize.length == 0) {
      alert("Enter minimum order size");
    } else if (securityOutstanding.length == 0) {
      alert("Enter security outstanding");
    } else if (securityAmount.length == 0) {
      alert("Enter security amount");
    } else if (currencyAmount.length == 0) {
      alert("Enter currency amount");
    } else if (
      props.existingIssue &&
      props.security.length === 0 &&
      enteredSecurity.length === 0
    ) {
      alert("Enter security address");
    } else if (
      props.existingIssue &&
      props.currency?.length === 0 &&
      currencyName === "Select Currency"
    ) {
      alert("Select currency to pair");
    }
    let securityTokenAddress, currencyTokenAddress;
    if (props.existingIssue) {
      securityTokenAddress =
        props.security.length > 0 ? props.security : enteredSecurity;
      props.updateSecurity(securityTokenAddress);
      const selectedCurrency = data.find(
        (token) => token.tokenName === currencyName,
      );
      currencyTokenAddress =
        props.currency?.length > 0
          ? props.currency
          : selectedCurrency.tokenAddress;
      props.updateCurrency(currencyTokenAddress);
      console.log("Here: ", securityTokenAddress, currencyTokenAddress);
    } else {
      const currencyToken = data.find(
        (element) => element.tokenAddress === props.currency,
      );
      currencyTokenAddress = currencyToken.tokenAddress;
      securityTokenAddress = props.security;
    }
    const cashContract = new web3.eth.Contract(ERC20ABI, currencyTokenAddress);
    const cashContractVer = new ERC20(signer, currencyTokenAddress);
    const currencyDecimals = await cashContract.methods.decimals().call();
    const cashBalance = await cashContract.methods.balanceOf(account).call();
    const securityTokenContract = new web3.eth.Contract(
      ERC20ABI,
      securityTokenAddress,
    );
    const securityDecimals = await securityTokenContract.methods
      .decimals()
      .call();
    const securitySymbol = await securityTokenContract.methods.symbol().call();
    const securityBalance = await securityTokenContract.methods
      .balanceOf(account)
      .call();
    const currencyAmountFixed = String(currencyAmount * 10 ** currencyDecimals);
    let securityContract;
    if (provider && provider.getSigner) {
      securityContract = new Security(signer, securityTokenAddress);
    }

    if (Number(securityBalance) < securityAmount) {
      toast.error("Insufficient Security Balance!", ToastOptions);
      return;
    } else if (Number(cashBalance) < currencyAmountFixed) {
      toast.error("Insufficient Currency Balance!", ToastOptions);
      return;
    }

    setLoading(true);
    if (!props.existingIssue) {
      try {
        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account,
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions,
            );

            return;
          }
          paymentToken = cashTokens[0];
          const txQuote = await securityContract._getMeeQuote(
            cashTokens[0]?.address,
            "whiteList",
            [
              contractAddress[chainId].BalancerSecondaryIssueManager,
              securityOutstanding?.toString(),
            ],
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions,
            );

            return;
          }
        }

        await securityContract
          .whiteList(
            contractAddress[chainId].BalancerSecondaryIssueManager,
            securityOutstanding?.toString(),
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )
          .then((res) => {
            if (res?.status === 0) {
              toast.success("Whitelist Successful", ToastOptions);
            }
            if (res?.status === 1) {
              setLoading(false);
              toast.error(FailureToast(), ToastOptions);
              return;
            }
            if (res?.code === "ACTION_REJECTED") {
              setLoading(false);
              toast.error("Transaction rejected by user!", ToastOptions);
              return;
            }
          });
      } catch (err) {
        setLoading(false);
        let error = { err };
        console.log(error);
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
        toast.error(FailureToast(transactionLink), ToastOptions);
        return;
      }
    }

    const currencyAllowance = Number(
      await cashContract.methods
        .allowance(account, secondaryIssueContract.contractAddress)
        .call(),
    );
    let isCurrencyApproved = false;
    let paymentToken;

    if (
      verifiedWalletDetails &&
      Object?.keys(verifiedWalletDetails)?.length > 0
    ) {
      const cashTokens = await getAllVerifiedCashBalances(
        chainId,
        web3,
        account,
      );

      if (!cashTokens || cashTokens?.length === 0) {
        setLoading(false);
        toast.error(
          "No valid Cash Token on this network. Change network and try again.",
          ToastOptions,
        );

        return;
      }
      paymentToken = cashTokens[0];
      const txQuote = await cashContractVer._getMeeQuote(
        cashTokens[0]?.address,
        "approve",
        [
          secondaryIssueContract.contractAddress,
          currencyAmountFixed?.toString(),
        ],
      );

      if (
        Number(cashTokens[0]?.balance) === 0 ||
        Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
      ) {
        setLoading(false);
        toast.error(
          `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
          ToastOptions,
        );

        return;
      }
    }

    await cashContractVer
      .approve(
        secondaryIssueContract.contractAddress,
        currencyAmountFixed?.toString(),
        paymentToken?.address
          ? {
              paymentToken: paymentToken?.address,
              apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
            }
          : {},
      )

      .then((res) => {
        if (res?.status === 0) {
          toast.success("Currency Approve Successful", ToastOptions);
          isCurrencyApproved = true;
        } else {
          isCurrencyApproved = false;
          setLoading(false);

          toast.error("Currency Approve Failed.", ToastOptions);
          return;
        }
      })
      .catch((err) => {
        isCurrencyApproved = false;
        setLoading(false);
        toast.error("Transaction failed", ToastOptions);
        return;
      });

    const securityAllowance = Number(
      await securityTokenContract.methods
        .allowance(account, secondaryIssueContract.contractAddress)
        .call(),
    );

    if (isCurrencyApproved && securityAllowance < Number(securityAmount)) {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await securityContract._getMeeQuote(
          cashTokens[0]?.address,
          "approve",
          [
            contractAddress[chainId].BalancerSecondaryIssueManager,
            securityAmount?.toString(),
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }
      await securityContract
        .approve(
          contractAddress[chainId].BalancerSecondaryIssueManager,
          securityAmount?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then(async (res) => {
          if (res?.status === 0) {
            toast.success("Security Approved Succesfully", ToastOptions);
            try {
              let paymentToken;

              if (
                verifiedWalletDetails &&
                Object?.keys(verifiedWalletDetails)?.length > 0
              ) {
                const cashTokens = await getAllVerifiedCashBalances(
                  chainId,
                  web3,
                  account,
                );

                if (!cashTokens || cashTokens?.length === 0) {
                  setLoading(false);
                  toast.error(
                    "No valid Cash Token on this network. Change network and try again.",
                    ToastOptions,
                  );

                  return;
                }
                paymentToken = cashTokens[0];
                const txQuote = await secondaryIssueContract._getMeeQuote(
                  cashTokens[0]?.address,
                  "setIssuingFee",
                  [
                    securityTokenAddress,
                    currencyTokenAddress,
                    ethers.utils
                      .parseUnits(issuingFee.toString(), 18)
                      .toString(),
                  ],
                );

                if (
                  Number(cashTokens[0]?.balance) === 0 ||
                  Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
                ) {
                  setLoading(false);
                  toast.error(
                    `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
                    ToastOptions,
                  );

                  return;
                }
              }
              await secondaryIssueContract
                .setIssuingFee(
                  securityTokenAddress,
                  currencyTokenAddress,
                  ethers.utils.parseUnits(issuingFee.toString(), 18).toString(),
                  paymentToken?.address
                    ? {
                        paymentToken: paymentToken?.address,
                        apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                      }
                    : {},
                )
                .then(async (_res) => {
                  if (_res?.status === 0) {
                    toast.success("Set Issue Fee Successfully", ToastOptions);

                    let paymentToken;

                    if (
                      verifiedWalletDetails &&
                      Object?.keys(verifiedWalletDetails)?.length > 0
                    ) {
                      const cashTokens = await getAllVerifiedCashBalances(
                        chainId,
                        web3,
                        account,
                      );

                      if (!cashTokens || cashTokens?.length === 0) {
                        setLoading(false);
                        toast.error(
                          "No valid Cash Token on this network. Change network and try again.",
                          ToastOptions,
                        );

                        return;
                      }
                      paymentToken = cashTokens[0];
                      const txQuote = await secondaryIssueContract._getMeeQuote(
                        cashTokens[0]?.address,
                        "issueSecondary",
                        [
                          securityTokenAddress,
                          currencyTokenAddress,
                          securityOutstanding?.toString(),
                          securityAmount?.toString(),
                          minOrderSize?.toString(),
                          currencyAmountFixed?.toString(),
                        ],
                      );

                      if (
                        Number(cashTokens[0]?.balance) === 0 ||
                        Number(txQuote?.amount) >
                          Number(cashTokens[0]?.balanceFmt)
                      ) {
                        setLoading(false);
                        toast.error(
                          `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
                          ToastOptions,
                        );

                        return;
                      }
                    }
                    await secondaryIssueContract
                      .issueSecondary(
                        securityTokenAddress,
                        currencyTokenAddress,
                        securityOutstanding?.toString(),
                        securityAmount?.toString(),
                        minOrderSize?.toString(),
                        currencyAmountFixed?.toString(),
                        paymentToken?.address
                          ? {
                              paymentToken: paymentToken?.address,
                              apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                            }
                          : {},
                      )
                      .then((fres) => {
                        setLoading(false);
                        if (fres?.status === 0) {
                          const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${fres?.response?.hash}`;
                          toast.success(
                            SuccessToast(transactionLink),
                            ToastOptions,
                          );
                          setChangeContent(true);
                          modalContent.current.innerHTML = "";
                        } else {
                          toast.error("Transaction Failed");
                          return;
                        }
                      });
                  } else {
                    setLoading(false);
                    toast.error("Set Issue Fee Failed.", ToastOptions);
                    return;
                  }
                });
            } catch (err) {
              let error = { err };
              console.log(error);
              const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err.transactionHash}`;
              setLoading(false);
              toast.error(FailureToast(transactionLink), ToastOptions);
              return;
            }
          } else {
            setLoading(false);
            toast.error("Security Approve Failed", ToastOptions);
            return;
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("Security Approve Failed", ToastOptions);
          return;
        });
    } else if (
      isCurrencyApproved &&
      securityAllowance >= Number(securityAmount)
    ) {
      try {
        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account,
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions,
            );

            return;
          }
          paymentToken = cashTokens[0];
          const txQuote = await secondaryIssueContract._getMeeQuote(
            cashTokens[0]?.address,
            "setIssuingFee",
            [
              securityTokenAddress,
              currencyTokenAddress,
              ethers.utils.parseUnits(issuingFee.toString(), 18).toString(),
            ],
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions,
            );

            return;
          }
        }
        await secondaryIssueContract
          .setIssuingFee(
            securityTokenAddress,
            currencyTokenAddress,
            ethers.utils.parseUnits(issuingFee.toString(), 18).toString(),
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )
          .then(async (_res) => {
            if (_res?.status === 0) {
              toast.success("Set Issue Fee Successfully", ToastOptions);

              let paymentToken;

              if (
                verifiedWalletDetails &&
                Object?.keys(verifiedWalletDetails)?.length > 0
              ) {
                const cashTokens = await getAllVerifiedCashBalances(
                  chainId,
                  web3,
                  account,
                );

                if (!cashTokens || cashTokens?.length === 0) {
                  setLoading(false);
                  toast.error(
                    "No valid Cash Token on this network. Change network and try again.",
                    ToastOptions,
                  );

                  return;
                }
                paymentToken = cashTokens[0];
                const txQuote = await secondaryIssueContract._getMeeQuote(
                  cashTokens[0]?.address,
                  "issueSecondary",
                  [
                    securityTokenAddress,
                    currencyTokenAddress,
                    securityOutstanding?.toString(),
                    securityAmount?.toString(),
                    minOrderSize?.toString(),
                    currencyAmountFixed?.toString(),
                  ],
                );

                if (
                  Number(cashTokens[0]?.balance) === 0 ||
                  Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
                ) {
                  setLoading(false);
                  toast.error(
                    `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
                    ToastOptions,
                  );

                  return;
                }
              }
              await secondaryIssueContract
                .issueSecondary(
                  securityTokenAddress,
                  currencyTokenAddress,
                  securityOutstanding?.toString(),
                  securityAmount?.toString(),
                  minOrderSize?.toString(),
                  currencyAmountFixed?.toString(),
                  paymentToken?.address
                    ? {
                        paymentToken: paymentToken?.address,
                        apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                      }
                    : {},
                )
                .then((fres) => {
                  setLoading(false);
                  if (fres?.status === 0) {
                    const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${fres?.response?.hash}`;
                    toast.success(SuccessToast(transactionLink), ToastOptions);
                    setChangeContent(true);
                    modalContent.current.innerHTML = "";
                  } else {
                    toast.error("Transaction Failed");
                    return;
                  }
                });
            } else {
              setLoading(false);
              toast.error("Set Issue Fee Failed.", ToastOptions);
              return;
            }
          });
      } catch (err) {
        let error = { err };
        console.log(error);
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err.transactionHash}`;
        setLoading(false);
        toast.error(FailureToast(transactionLink), ToastOptions);
        return;
      }
    }
  };
  return (
    <>
      <ToastContainer />
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.existingIssue
              ? props.onIssuedModalHide()
              : props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          {props.existingIssue && props.security?.length === 0 && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Security Address</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <TextInput
                  placeholder="Security Address"
                  required
                  onChange={(e) => setEnteredSecurity(e.target.value)}
                />
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Minimum Security Order</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Minimum order size"
                fieldType="number"
                required
                onChange={(e) =>
                  setMinOrderSize(web3.utils.toWei(e.target.value, "ether"))
                }
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Security Outstanding</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Number of total securities outstanding"
                fieldType="number"
                required
                onChange={(e) =>
                  setSecurityOutstanding(
                    web3.utils.toWei(e.target.value, "ether"),
                  )
                }
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Security Amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Number of securities to issue"
                fieldType="number"
                required
                onChange={(e) =>
                  setSecurityAmount(web3.utils.toWei(e.target.value, "ether"))
                }
              />
            </Col>
          </Row>
          {props.existingIssue && props.currency?.length === 0 && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Currency to pair</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton id="dropdown-basic-button" title={currencyName}>
                  {data?.map((token, idx) => (
                    <Dropdown.Item
                      key={idx}
                      onClick={(e) => setCurrencyName(token?.tokenName)}
                    >
                      {token?.tokenName}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Currency Amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Equivalent cash value"
                fieldType="number"
                required
                onChange={(e) => setCurrencyAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Issuing Fee</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Equivalent cash value"
                fieldType="number"
                required
                onChange={(e) => setIssuingFee(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={async () => {
                  if (web3 && signer && account && chainId) {
                    await addIssue();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Create Issue"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export default function AddOffer(props) {
  return <NewOffer {...props} />;
}
